import { defineComponent as _defineComponent } from 'vue'
import { TncDialog } from '@tencent/wphk-act-base-ui';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'lottery-tnc',
  props: {
  tncUrl: {
    type: String,
    required: true,
  },
},
  setup(__props) {



const tncDialog = ref();

/**
 * 点击 TNC 条款
 */
const onClickTnc = () => {
  tncDialog.value?.showTncDialog();
};

return { __sfc: true,tncDialog, onClickTnc, TncDialog }
}

})